<template>
    <el-dialog title="Photo" v-loading="loader" :visible.sync="display" width="50%">
        <div class="mb-3">Modifier les {{ items_selected }} produits selectionnés</div>
        <el-form class="formChangePhoto" ref="form" :model="form">
            <el-form-item prop="photo">
                <el-input @change.native="handleChange" type="file" placeholder="Photo" v-model="form.photo"></el-input>
            </el-form-item>
            <el-form-item prop="replace"  class="text-left">
                <el-checkbox v-model="form.replace">Annule est remplace les images</el-checkbox>
            </el-form-item>
        </el-form>

        <div class="preview" v-if="preview">
            <img :src="preview" class="rounded">
        </div>

        <span slot="footer" class="dialog-footer">
            <el-switch v-model="sync" active-text="Synchroniser ?"></el-switch>
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            preview: null,
            file: null,
            sync: false,
            form: {
                photo: null,
                replace: false
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        handleChange($event)
        {
            var file      = $event.target.files[0]
            var reader    = new FileReader();
            reader.onload = (e) => {
                this.preview  = e.target.result;
            }
            reader.readAsDataURL(file);
            this.file = file;
        },
        action() {
            var products = this.selected.map(v => v.id);
            this.loader = true;
            var formData = new FormData;
            formData.append('mode', 'change_photo')
            formData.append('replace', this.form.replace)
            formData.append('photo', this.file)
            formData.append('total_item', this.total_item)
            formData.append('items_selected', this.items_selected)
            formData.append('sync', this.sync)
            products.forEach((value, index)=>{
                formData.append('products['+index+']', value)
            })

            if (this.applyToAllResult) {
                for(var i in this.filters) {
                    if( this.filters[i] !== null ) {
                        formData.append('filters['+i+']', this.filters[i])
                    }
                }
                //datas.filters = this.filters;
            }
            axios
                .post('/products/bulk', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(r => {
                    this.$emit('saved', r);
                    this.$refs.form.resetFields();
                    this.file = null;
                    this.preview = null;
                    this.display = false;
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        }
    }
};
</script>
